const dateFormat = (date: string, short: boolean = false): string | null => {
  if (!date) {
    return null;
  }

  const [y, m, d] = date.split("-");
  const yy = short ? y.substr(2, 2) : y;
  return `${d}.${m}.${yy}`;
};

export { dateFormat };
